'use strict';

var currentSubmissionUrl = document.getElementById('currentSubmissionUrl');
currentSubmissionUrl.value = window.location.href;
